export function debounce(millis, fn) {
    var timeout;
    return function exec(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(args), millis);
    };
}
